import { VacancySyncState } from "./api/types";

export function isValidVacancySyncState(value: number): value is VacancySyncState {
  return (
    value === VacancySyncState.Synced ||
    value === VacancySyncState.Removed ||
    value === VacancySyncState.NotSynced
  );
}

export function parseVacancySyncState(value: string): VacancySyncState | null {
  const numValue = Number(value);
  if (Number.isNaN(numValue)) {
    return null;
  }
  return isValidVacancySyncState(numValue) ? numValue : null;
}
